// 2026-09-24 - FormuLearning - Step 3 X 변수 외부 갱신 신호 (이슈 #75 G4)
// 파일 위치: frontend/src/stores/step3SyncStore.ts
// 목적: Step 1 에서 대조약을 골라 Step 3 의 X 변수·총중량을 서버에 갈아끼우면(BR-S3-10)
//       함께 마운트된 Step 3 카드가 옛 로컬 상태를 들고 있다가 다음 저장 때 되돌려 쓴다.
//       revision 을 올려 Step 3 카드가 그 필드를 서버 기준으로 다시 읽게 한다(lotStore 와 같은 방식).

import { create } from 'zustand'

interface Step3SyncState {
  /** Step 3 밖에서 X 변수·총중량을 바꿀 때마다 증가. 구독자는 변경 시 서버 재조회한다. */
  revision: number
  bump: () => void
}

export const useStep3Sync = create<Step3SyncState>((set) => ({
  revision: 0,
  bump: () => set((s) => ({ revision: s.revision + 1 })),
}))
